export const URLS = Object.freeze({
  BO_V1: process.env.BO_V1 || 'https://admin.p.gtrsuite.com',
  BO_V2: process.env.BO_V2 || 'https://local.gtrsuite.com:9000',
  BO_V3: process.env.BO_V3 || 'https://local.gtrsuite.com:9001',
  SSO: process.env.SSO || 'https://sso.p.gtrsuite.com',
  SEMANTIC_URL: 'https://bot-statistics-v3.netlify.app/',
  SUPER_ADMIN: process.env.SUPER_ADMIN || 'https://brain.p.gtrsuite.com',
})
